import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'
import App from './App.jsx'
import { HelmetProvider } from 'react-helmet-async'; // <-- Import this

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider> {/* <-- Wrap your App here */}
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);